/**
 * Renders an HTML string in a new browser tab by wrapping it in a blob URL.
 *
 * @throws if the browser blocks opening the new tab (e.g. a popup blocker).
 */
export function openHtmlInNewTab(html: string): void {
	const blob = new Blob([html], { type: 'text/html; charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const newWindow = window.open(url, '_blank');

	if (!newWindow) {
		URL.revokeObjectURL(url);
		throw new Error('Unable to open window');
	}
}
